export default class Location {
  constructor({ title, address, id, url, coordinates, map, ischedule_url }) {
    this._title = title;
    this._address = address;
    this._id = id;
    this._url = url;
    this._ischedule_url = ischedule_url;
    this._coordinates = coordinates;
    this._map = map;

    this._popupTemplate = document.getElementById("marker-popup-template");
    this._element = this._popupTemplate.content.firstElementChild.cloneNode(true);

    this._initView();
  }

  /* ---------------------------- Marker Setter ---------------------------- */
  set marker(marker) {
    this._marker = marker;
    this._marker.setMap(this._map);
  }

  /* ---------------------------- Marker Getter ---------------------------- */
  get marker() {
    return this._marker;
  }

  /* ------------------------- InfoWindow Setter -------------------------- */
  set infoWindow(infoWindow) {
    this._infoWindow = infoWindow;
  }

  /* ------------------------- InfoWindow Getter -------------------------- */
  get infoWindow() {
    return this._infoWindow;
  }

  /* ------------------------------ Map Getter ----------------------------- */
  get map() {
    return this._map;
  }

  /* -------------------------- Coordinates Getter ------------------------- */
  get coordinates() {
    return this._coordinates;
  }

  /* --------------------------- Distance Getter --------------------------- */
  get distance() {
    return this._distance;
  }

  /* --------------------------- Distance Setter --------------------------- */
  set distance(distance) {
    this._distance = distance;
    const distanceDisplayEl = this._element.querySelector(".location-marker-popup__distance");
    distanceDisplayEl.textContent = `${distance.toFixed(2)} miles`;
  }

  /* ---------------------------- Deactivate Marker ------------------------ */
  deactivate() {
    this._marker.setMap(null);
    this._infoWindow.close();
  }

  /* ----------------------------- Activate Marker ------------------------ */
  activate() {
    this._marker.setMap(this._map);
  }

  /* --------------------------- List Item Click Handler ------------------- */
  onListItemClick(fn) {
    this._element.addEventListener("click", (e) => fn(e, this));
  }

  /* ------------------------- Close InfoWindow --------------------------- */
  closeInfoWindow() {
    this._infoWindow.close();
  }

  /* -------------------------- Open InfoWindow --------------------------- */
  openInfoWindow() {
    this._infoWindow.open({
      anchor: this._marker,
      map: this._map,
    });
  }

  /* -------------------------- Unfocus List Item -------------------------- */
  unFocusListItem() {
    this._element.classList.remove("location-finder__location-item--focus");
  }

  /* --------------------------- Focus List Item --------------------------- */
  focusListItem() {
    this._element.classList.add("location-finder__location-item--focus");
    this._element.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
      inline: "start",
    });
  }

  /* -------------------------- Initialize View ---------------------------- */
  _initView() {
    // Set title link if it exists
    const link = this._element.querySelector(".location-marker-popup__link");
    if (link) {
      link.textContent = this._title;
      link.href = this._url;
    }

    // Set address
    this._element.querySelector(".location-marker-popup__address").textContent = this._address;

    const buttonsContainer = this._element.querySelector(".location-marker-popup__buttons");
    buttonsContainer.innerHTML = ""; // Clear any existing buttons
    
    const enableISchedule = window.ENABLE_ISCHEDULE;
    const phone = window.QUALSIGHT_PHONE;
    
    if (enableISchedule) {
      if (this._ischedule_url) {
        // Show Schedule Free Consultation button
        const scheduleBtn = document.createElement("a");
        scheduleBtn.href = this._ischedule_url;
        scheduleBtn.textContent = "Schedule Free Consultation";
        scheduleBtn.className = "location-marker-popup__button location-marker-popup__button--ischedule button button--style--primary";
        buttonsContainer.appendChild(scheduleBtn);
      } else {
        // Show Phone Button
        const phone = window.QUALSIGHT_PHONE;
        const phoneRaw = window.QUALSIGHT_PHONE_RAW;
        
        const callBtn = document.createElement("a");
        callBtn.href = `tel:${phoneRaw}`;
        callBtn.textContent = `Call ${phone}`;
        callBtn.className = "location-marker-popup__button location-marker-popup__button--phone button button--style--primary-outlined";
        //callBtn.setAttribute("data-tippy-content", `Call <a href="${phoneRaw}">${phone}</a>`);
        buttonsContainer.appendChild(callBtn);
      }
    } else {
      // Show default Request Appointment
      const requestBtn = document.createElement("a");
      requestBtn.href = "/free-lasik-exam?location=" + encodeURIComponent(this._title);
      requestBtn.textContent = "Request Appointment";
      requestBtn.className = "location-marker-popup__button location-marker-popup__button--req button button--style--primary";
      buttonsContainer.appendChild(requestBtn);
    
      // Show More Info linking to location detail
      const infoBtn = document.createElement("a");
      infoBtn.href = this._url;
      infoBtn.textContent = "More Info";
      infoBtn.className = "location-marker-popup__button location-marker-popup__button--info button button--style--primary-outlined";
      buttonsContainer.appendChild(infoBtn);
    }


    // Wrap in list item
    const li = document.createElement("li");
    li.className = "location-finder__location-item";
    li.append(this._element);

    this._element = li;
  }

  /* --------------------------- Get List View ----------------------------- */
  getView() {
    return this._element;
  }

  /* -------------------------- Get Popup HTML ----------------------------- */
  getPopupView() {
    return this._element.firstElementChild.outerHTML;
  }
}
